export default {"src":"/_next/static/media/arrow-bottom.c1dcb366.svg","height":7,"width":10,"blurWidth":0,"blurHeight":0};